module.exports = __webpack_public_path__ + "static/media/festival_05.dd65dced.jpg";